import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { Page } from '../modules/roles/models/role-model';
import PortfolioAccessDenied from '../modules/portfolio/PortfolioAccessDenied';
import {useProjectSelection} from '../modules/projectdetails/hooks/useProjectSelection';
import {isSelectionRouteDisabled, singleProjectLandingRoute} from '../modules/projectdetails/selectionMode';

type Props = {
  component: React.ComponentType<any>;
  id?: string;
  page?: string;
  path: string;
  exact?: boolean;
  permission: string[];
  activePages: Page[];
  label?: string;
};

const ActivatedPageRoute: React.FC<Props> = ({
  id: id,
  page: page,
  component: Component,
  permission,
  activePages,
  label,
  path,
  ...rest
}) => {
  const {isPortfolio} = useProjectSelection();
  return (
    <Route
      {...rest}
      path={path}
      render={props => {
        const allowed = Array.isArray(permission)
          ? permission.some(perm => activePages.some(page => page.name === perm))
          : activePages.some(page => page.name === permission);
        if (isSelectionRouteDisabled(props.location.pathname, isPortfolio)) {
          return <Redirect to={isPortfolio ? '/portfolio-overview' : singleProjectLandingRoute(activePages.map((page) => page.name))} />;
        }
        if (!allowed && isPortfolio && path === '/portfolio-overview') {
          return <PortfolioAccessDenied pageNames={activePages.map((page) => page.name)} />;
        }
        return allowed ? (
          <Component id={id} page={page} path={props.match.url} label={label} {...props} />
        ) : (
          <Redirect to='/error/404' />
        );
      }}
    />
  );
};

export default ActivatedPageRoute;
